import React, { Fragment, useRef } from 'react'
import { Table, TableBody, TableCell, TableContainer,
   TableHead, TableRow, Paper, TablePagination} from '@mui/material';
import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import EmailMasterEditable from './EmailMasterEditable';
import EmailMasterReadOnly from './EmailMasterReadOnly';
import { useEffect } from 'react';
import * as XLSX from 'xlsx'
import Popup from 'reactjs-popup';
import PopupTable from '../../PopupTable';
import { useAddBulkemailmasterMutation, useAddNewemailmasterMutation, useDeleteemailmasterMutation, useGetemailmasterQuery, useUpdateemailmasterMutation } from '../../../features/emailmaster/emailMasterApiSlice';
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import ExcelDownload from '../../../data/exceldownload';





const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;


const Addcategcont =styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
`
const Addcategform = styled.form`
  display: flex;
  margin:10px;
`
const Displaydiv1 = styled.div`

`
const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom:20px;
  margin-top:15px;
`
const FormEleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items:center;
`
const Button2Div =styled.div`
  display: flex;
  justify-content: end;
`

const AssetCategoryWrapper = styled.div`

`
const Label = styled.label`
    width: 140px;
    margin: 10px;
`

const SuggestSearchWrapper = styled.div`

`
const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
`
const CustomFileUploadButton = styled.label`
  /* Add your desired button styles */
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`
const BulkWrapper = styled.div`
  display: flex;
  align-items:center;
`

const FormItemdiv = styled.div`

`
const ViewModalWrapper = styled.div`
    font-size: 12px;
`
const CloseModalButton = styled.button`
  cursor: pointer;
  position: absolute;
  display: block;
  padding: 2px 5px;
  line-height: 20px;
  right: -10px;
  top: -10px;
  font-size: 24px;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid #cfcece;
`
const InputFile = styled.input`
  width: 180px;
  display: none;
`
const SearchDiv =styled.div`
  position: absolute;
  background-color: white;
  overflow-y: auto;
  height: 400px;
  z-index: 100;
  /* outline: 1px solid black; */
`

const SelectFileReset = styled.button`
  margin-right: 10px;
`
const ComplaintCategoryWrapper =styled.div`
  display: flex;
  align-items: center;
  justify-content:space-between;

`

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const tableFontSize = 18;


export default function CustomPaginationActionsTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const {emailmaster} = useGetemailmasterQuery("emailmasterList", {
    selectFromResult: ({ data }) => ({
      emailmaster: data?.entities
    }),
  })

  const [addNewEmailMaster] = useAddNewemailmasterMutation();
  const [addBulkEmailMaster] = useAddBulkemailmasterMutation() ;
  const [updateEmailMaster] = useUpdateemailmasterMutation() ;
  const [deleteEmailMaster] = useDeleteemailmasterMutation();

  const inputFile = useRef(null);
  const [tabledata, setTabledata]= useState([]);
  const [editCategory, setEditCategory]=useState(null);
  const [editFormData, setEditFormData]=useState({});
  const [addEmailMasterData, setAddEmailMasterData] = useState({});
  const [assetCategory, setAssetCategory]=useState([]);
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(null);
  const [duplicateValues, setDuplicateValues] = useState();
  const [invalidValues, setInvalidValues] = useState();
  const [finalFile, setFinalFile] = useState([]);
  const [downloadData, setDownloadData] = useState({});
  const [bulkDataAdded, setBulkDataAdded] = useState(false);
  const [sentData, setSentData ]= useState(0);
  const [fileName, setFileName] = useState("");
  const [subject, setSubject] = useState({
    subjectValue: [...Array(tabledata.length).fill("")],
    subjectIndex: ""
  });
  const [validEmailId, setValidEmailId] = useState(false);
  const [emailIDFocus, setEmailIdFocus] = useState(false);

     // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onSubmit = async (event) =>{
    event.preventDefault();
    console.log(addEmailMasterData)
    try{
      let bodyobject ={"name":addEmailMasterData.name.trim()};
      const found = Object.values(emailmaster).some(el => el.name === addEmailMasterData.name);
   if(!found && addEmailMasterData?.name?.length ){
      const res = await addNewEmailMaster(bodyobject) ;
      alert(`New emailId ${bodyobject.name} added in masters.`)
      setAddEmailMasterData({});
      setSentData(sentData+1);
      }
    } catch(err){console.log(err)}
    setAddEmailMasterData({})
  }

  const onClickEdit = (e,k,row)=>{

    if((subject.subjectValue[k] === "") ||(subject.subjectValue[k] === undefined)){
      const temp = {...subject}
      temp.subjectIndex ="";
      setSubject(temp);
    }
    setEditCategory(k+1);

  }

  const onChangeAddEmailMaster = (event) =>{
    console.log(event.target.value)
    let temp ={...addEmailMasterData}
    temp = {...temp, [event.target.name]:event.target.value}
    setAddEmailMasterData(temp);

    // let temp ={...addDesgnData}
    // if(event.target.name?.length){
    //   temp = {...temp, [event.target.name]:event.target.value}
    // }
    // if(name?.length){
    //   temp = {...temp, [name]:newValue}
    // }
    // console.log(temp)
    // setAddDesgnData(temp);
  }

  const onChangeEditDesgn = (event) =>{
    let temp ={...editFormData}    
    temp = {...temp, [event.target.name]:event.target.value}    
    setEditFormData(temp);
  }

  const handleButtonClick = () => {
    inputFile.current.click();
  }; 

  const handleEditFormSubmit = async (e) =>{
    e.preventDefault();
    try{
    setEditCategory(null);
    const id = tabledata[((page)*(rowsPerPage))+(editCategory-1)].id;
    let body ={}
    if (editFormData[`emailmaster${editCategory-1}`] !== undefined){ 
    body = {...body,"id":id, "name":editFormData[`emailmaster${((page)*(rowsPerPage))+(editCategory-1)}`].trim() }
    }
    const response = await updateEmailMaster(body)
    setSentData(body);
    }catch(err){}
  }  

  const handleCancelClick = (e,k) => {    
    const tempObject = {...subject};
    tempObject.subjectValue[k] = "";
    setEditCategory(null);
    setSubject(tempObject);
  };

  const handleDeleteClick = async (e,k,row) => {
    e.preventDefault();
    let body = {"id":row.id}
    const response = window.confirm(`Do you want to delete Email Id "${row.name}"` )
    if(!response) return;
    alert(`Email Id "${row.name}" deleted successfully`);
    const result = await deleteEmailMaster(body);
  };

  const assignFunction = (data) => {
    setFile(data);
    let reducedArray = [];
    let invalidValues = [];
    const tempArray = [...data];
    for(let val of tempArray){
      let tempObj = {name:val.name}
      if(EMAIL_REGEX.test(val.name)){
      reducedArray.push(tempObj)
      }else{
        invalidValues.push(tempObj)
      }
    }
    setInvalidValues(invalidValues);
    const nameArray = Object.values(emailmaster).map(item => item.name);
    setDuplicateValues(reducedArray.filter(item => nameArray.includes(item.name)));   
    setFinalFile((reducedArray.filter(item => !nameArray.includes(item.name))));
  }

  const onBulkSubmit = async (e) =>{
    e.preventDefault();   
    const result = await addBulkEmailMaster(finalFile);
    if(result.data.acknowledged){
      setBulkDataAdded(true);      
    }
  }

  const deleteSelectFile = () => {
    if(inputFile.current){
      inputFile.current.value = "";
      inputFile.current.type = "text"; 
      inputFile.current.type = "file";
      setFile(null)
    }
  }

  const fileType = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"]
  const handleChangeEmail = (e) => {
    let selectedFile = e.target.files[0]
    if(selectedFile){
      if(fileType.includes(selectedFile.type)){
        setFileName(selectedFile.name)
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile)
        reader.onload = (e) => {
          setFileError(null);
          const workbook = XLSX.read(e.target.result, {type:'buffer' });
          const worksheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[worksheetName];
          const data = XLSX.utils.sheet_to_json(worksheet);
          assignFunction(data);
        }
      }else{
        setFileError("Please Select Correct File Type")
        setFile(null)
      }
    }else{
      setFileError("no file selected")
      setFile(null) 
    }
  } 

  useEffect(()=>{
    if(emailmaster){
      const emailmasterArray = Object.values(emailmaster);
      setTabledata(emailmasterArray);
      let temp = {...editFormData};
      for(let i=0;i< emailmasterArray.length;i++){
        temp = {...temp, [`emailmaster${i}`]:emailmasterArray[i].name}
      }
      setEditFormData(temp);
    }
  },[emailmaster])

  useEffect(() => {
    setValidEmailId(EMAIL_REGEX.test(addEmailMasterData.emailmaster));        
  }, [addEmailMasterData.emailmaster])

//Setting the download data for excel download.
useEffect(()=>{
  let finalDownloadData = [];
  let finalSortedDownloadData = [];
  const keyOrderArray = ["name"]
  let tempDownloadData = structuredClone(tabledata);
  for(let val of tempDownloadData ){
      let {_id, ...others} = val;
      others = {...others, ["name"]: val.name }
      finalDownloadData.push(others)
    }
    for(let value of finalDownloadData){
        let tempObject = {}
        for(let val of keyOrderArray){
            tempObject = {...tempObject, [val]:value[val]};
        }
        finalSortedDownloadData.push(tempObject);
    }
    setDownloadData(finalSortedDownloadData)
}, [tabledata])
 
   
  return (
    <>
   
    <Displaydiv1>
      <HeadingWrap>
        <Span>Add New Email Id</Span>
      </HeadingWrap>

    <ComplaintCategoryWrapper>
      <Addcategform onSubmit={onSubmit}>
        <FormEleWrapper>
          <TextField
            id="outlined-basic"
            size='small'
            name='name'
            onChange={(event) => onChangeAddEmailMaster(event)}
            label="Enter an Email"
            value={addEmailMasterData?.name || ""}
            variant="outlined"
            sx={{backgroundColor:"white", width:"200px", height:"40px"}}
          />
        <SubmitButton type='submit'>Submit</SubmitButton>
        </FormEleWrapper>        
      </Addcategform>
      <Button2Div>
          <ExcelDownload data={downloadData} filename={"emailMaster"} sheetName={"sheet1"}/>
        </Button2Div> 
    </ComplaintCategoryWrapper>

    <form onSubmit={handleEditFormSubmit}>

    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}  >
      <Table  aria-label="custom pagination table">
      <TableHead>
        <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"25%"}}}align="left">Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"30%"}}} align="left">Email Id</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"30%"}}} align="left">Edit</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, key) => ( 
            <Fragment key={key*2}>
              {editCategory=== key+1 ?
              
               <EmailMasterEditable row={row} k={key} editFormData={editFormData} subject={subject} 
                handleCancelClick={handleCancelClick} page={page} rowsPerPage={rowsPerPage} editCategory={editCategory} onChangeEditDesgn={onChangeEditDesgn} assetCategory={assetCategory} SubmitButton ={SubmitButton} 
               />

                :<EmailMasterReadOnly row={row} k={key} tabledata={tabledata} onClickEdit={onClickEdit}
                  handleDeleteClick= {handleDeleteClick} page={page} rowsPerPage={rowsPerPage} tableFontSize={tableFontSize} SubmitButton ={SubmitButton}              
                />
                 }
            </Fragment>                   
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </form>

    <form onSubmit={onBulkSubmit}>
      <HeadingWrap>
        <Span>Upload Bulk Email Ids</Span>
      </HeadingWrap>

      <BulkWrapper>
        <InputFile type="file" onChange={handleChangeEmail} ref={inputFile} />
        <CustomFileUploadButton htmlFor="file-upload" onClick={handleButtonClick}>
          Upload File
        </CustomFileUploadButton>
      {file && <><span>{fileName}</span><SelectFileReset type='button' onClick={() => deleteSelectFile()} >&times;</SelectFileReset>
      <Popup trigger={<SubmitButton type='button'>View File</SubmitButton>} position="right center" modal nested>
              <PopupTable props={file}/>
      </Popup></>}
      <SubmitButton type='submit'>Submit</SubmitButton>
      </BulkWrapper>
    </form>
    </Displaydiv1>
    </>
  );
}